import { createVNode } from 'vue'
import { message } from 'ant-design-vue'
import axios from 'axios'
import qs from 'qs'

import store from '../store/index'
import levelMessage from '@/components/$Message/levelMessage.vue'
import { twPageUrl } from '@/utils/twPageUrl/twPageUrl'

window.flagTag = 0

let twinsmtURL = ''

if (window.__POWERED_BY_QIANKUN__) {
  twinsmtURL = twPageUrl()
}
// 创建axios实例
const service = axios.create({
  baseURL: twinsmtURL,
  timeout: 30000000, // 请求超时时间
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
  },
  withCredentials: true, // 跨域
})

// request拦截器
service.interceptors.request.use(
  (config) => {
    const urlParams = new URLSearchParams(window.location.search)
    const enterpriseIdBk = urlParams.get('enterpriseId')

    // 接口请求可在此处统一处理
    const token = localStorage.token
    const iolCode = localStorage.iolcode
    const enterpriseId =
      sessionStorage.getItem('enterpriseId') || enterpriseIdBk || ''
    const reg = new RegExp(/post|put|patch/i)

    if (enterpriseId) {
      config.headers['X-Enterprise-Id'] = enterpriseId
    }

    if (token) {
      config.headers['token'] = token //让每个请求携带自定义token 请根据实际情况自行修改
      config.headers['iolCode'] = iolCode
      config.headers['Authorization'] = 'Bearer ' + token // token;
      //共建项目单独处理移除 token Bearer；
      if (config.isClearBearer) {
        config.headers['Authorization'] = token
        delete config.headers.token
      }
    }

    for (let key in config.data) {
      // console.log(config.data[key])
      if (
        config.data[key] === '' ||
        config.data[key] === null ||
        config.data[key] === undefined
      ) {
        delete config.data[key]
      }
    }

    if (enterpriseId) {
      //非常莫名奇妙的问题，居然没有对象值导致直接报错；
      if (!config.data) {
        config.data = {}
      }
      if (!config.params) {
        config.params = {}
      }

      if (reg.test(config.method.toLocaleLowerCase())) {
        if (config.data === 'object' && config.data instanceof FormData) {
          config.data.append('enterpriseId', enterpriseId)
        } else {
          config.data.enterpriseId = enterpriseId
        }
      } else {
        config.params.enterpriseId = enterpriseId
      }
    }

    if (
      config.data &&
      config.headers['Content-Type'] ===
        'application/x-www-form-urlencoded;charset=UTF-8'
    ) {
      config.data = qs.stringify(config.data)
    }
    return config
  },
  (err) => {
    // 接口请求出错可在此处统一处理
    return Promise.resolve(err)
  }
)

// respone拦截器
service.interceptors.response.use(
  (data) => {
    const res = data.data
    if (res.errorCode == '000002') {
      message.destroy()
      message.error(res.errorMsg)
      localStorage.clear()
      store.commit('user/changeKey', {
        userInfo: {},
      })
      store.dispatch('user/getDictionary')
      const url = encodeURIComponent(location.href)
      window.location.href = window.env.login + '/cas/login?service=' + url
      return false
    } else if (res.errorCode == '000008') {
      message.destroy()
      message.success({
        icon: createVNode('span'),
        content: createVNode(levelMessage, { msg: res.errorMsg || res.msg }),
        duration: 3,
      })
      return false
    } else if (res.errorCode == '813018') {
      message.error(res.errorMsg)
      setTimeout(() => {
        window.location.href =
          window.location.origin +
          `/home?enterpriseId=${sessionStorage.getItem('enterpriseId') || 'personal'}&t=1234`
      }, 500)
    } else if (res.errorCode) {
      message.destroy()
      message.error(res.errorMsg)
      return false
    } else if (res.errno) {
      message.destroy()
      message.error(res.msg)
      return false
    }
    return data
  },
  (err) => {
    message.destroy()
    const status = err?.response?.status
    const data = err?.response?.data
    if (status === 401 && !location.hostname.includes('localhost')) {
      localStorage.token = ''
      const url = encodeURIComponent(location.href)
      window.location.href = window.env.login + '/cas/login?service=' + url
    }
    if (status == 409) {
      window.location.href = `/go/pe_pc_login/selectEnterprise?fromPage=${location.href}`
      return
    }
    message.error(
      data?.message || data?.errorMsg || '服务器或网络异常，请稍后重试'
    )
    return Promise.resolve(err)
  }
)

export default service
